<template>
  <div v-if="acc" class="user_wrap">
    <section class="account_hero">
      <div class="hero_background" />
      <div class="hero_content">
        <div class="account_bar">
          <div class="brand_mark"><img :src="profileImage" alt=""></div>
          <div class="account_identity">
            <div class="account_name_line">
              <div class="account_mobile">{{ acc.mobile }}</div>
              <span v-if="acc.vip" class="vip_badge">{{ acc.vip.name }}</span>
            </div>
            <div class="account_meta">
              <span>{{ $t('d.creditscore') }}: {{ acc.credit }}</span>
            </div>
          </div>
          <button type="button" class="setting_button" @click="$router.push('/set')"><van-icon name="setting-o" size="22" /></button>
        </div>

        <div class="balance_card">
          <div class="balance_top">
            <div>
              <p class="balance_label">{{ $t('d.balance') }}</p>
              <p class="balance_amount">{{ 1 * data.money }}</p>
            </div>
            <button type="button" class="recharge_button" @click="$router.push('/invest')"><van-icon name="add" /></button>
          </div>
          <div class="balance_divider" />
          <div class="balance_stats">
            <div class="stat_item"><p>{{ 1 * data.frozenmoney }}</p><span>{{ $t('d.frozen') }}</span></div>
            <div class="stat_item"><p>{{ 1 * data.reward }}</p><span>{{ $t('d.todayrewards') }}</span></div>
          </div>
        </div>
      </div>
    </section>

    <main class="user_content">
      <section class="invite_card">
        <div class="invite_copy"><span>{{ $t('d.code') }}</span><strong>{{ data.yaocode }}</strong></div>
        <button type="button" class="copy_button" @click.stop="copyYaocode">{{ $t('invest_bank.copy') }}</button>
      </section>

      <section class="vip_group">
        <div class="vip_group_txt">{{ $t('pro2.upvip') }}</div>
        <img src="../images/ban3/vip.png" alt="" class="vip_group_img">
      </section>

      <section class="menu_section">
        <van-cell v-for="item in menuItems" :key="item.route" is-link class="menu_item" @click="$router.push(item.route)">
          <template #title>
            <span class="menu_icon"><van-icon :name="item.icon" size="20" /></span>
            <span class="custom-title">{{ $t(item.label) }}</span>
          </template>
        </van-cell>
      </section>

      <button type="button" class="logout_button" @click="logout">{{ $t('safe.signOut') }}</button>
    </main>

    <van-popup v-model="show" round class="notice_popup">{{ msg }}</van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import brandLogo from '../images/forever-link-logo-transparent.png';
import {
  Icon,
  Cell,
  Popup,
} from 'vant';

Vue.use(Cell).use(Icon).use(Popup);

export default {
  name: 'User',
  data() {
    return {
      data: {},
      islogin: false,
      show_kefu: false,
      acc: null,
      msg: null,
      show: false,
      app: null,
      bodyScrollHandler: null,
      documentClickHandler: null,
      menuItems: [
        { route: '/cash', icon: 'share-o', label: 'user.withdraw' },
        { route: '/cashlist', icon: 'certificate', label: 'user.withdrawalRecord' },
        { route: '/funds', icon: 'debit-pay', label: 'pro2.transactionhis' },
        { route: '/order', icon: 'peer-pay', label: 'feng.order' },
      ],
    };
  },
  computed: {
    profileImage() {
      return this.app && this.app.fuli1 ? this.app.fuli1 : brandLogo;
    },
  },
  created() {
    this.$parent.footer('user');
  },
  mounted() {
    this.islogin = localStorage.getItem('token') !== null;
    if (!this.islogin) {
      this.$router.push('/login');
      return;
    }
    this.start();
    this.bodyScrollHandler = this.handleBodyScroll.bind(this);
    this.documentClickHandler = this.handleDocumentClick.bind(this);
    document.body.addEventListener('scroll', this.bodyScrollHandler, false);
    document.addEventListener('click', this.documentClickHandler, false);
  },
  beforeDestroy() {
    if (this.bodyScrollHandler) {
      document.body.removeEventListener('scroll', this.bodyScrollHandler, false);
    }
    if (this.documentClickHandler) {
      document.removeEventListener('click', this.documentClickHandler, false);
    }
  },
  methods: {
    handleBodyScroll() {
      if (this.show_kefu) {
        this.show_kefu = false;
      }
    },
    handleDocumentClick(event) {
      if (event.target.className !== 'kefu_img') {
        this.show_kefu = false;
      }
    },
    sync() {
      Fetch('/index/sync', {}, null, false).then((r) => {
        const notices = r.data;
        if (notices && notices.length > 0) {
          this.msg = notices[0].content;
          this.show = true;
          setTimeout(() => {
            Fetch('/user/notice_view', { id: notices[0].id });
          }, 2000);
        }
      });
    },
    copy() {
      this.$toast({ background: '#2c190f', message: this.$t('invest_qrcode.copySucceeded') });
    },
    copyYaocode() {
      const yaocode = this.data && this.data.yaocode;
      this.copyText(yaocode === undefined || yaocode === null ? '' : String(yaocode));
    },
    copyText(text) {
      if (!text) return;
      if (this.copyTextBySelection(text)) {
        this.copy();
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.copy()).catch(() => {});
      }
    },
    copyTextBySelection(text) {
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', 'readonly');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      input.style.top = '0';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      document.body.removeChild(input);
      return copied;
    },
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data;
      });
      Fetch('/user/info').then((r) => {
        this.data = r.data;
        this.acc = r.data;
      });
      setTimeout(() => this.sync(), 2000);
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace('/');
    },
  },
};
</script>

<style lang="less" scoped>
.user_wrap { min-height: 100vh; background: linear-gradient(180deg, #fffaf0 0, #fff6e7 48%, #f8ead4 100%); color: #3e2117; }
.account_hero { position: relative; min-height: 276px; overflow: hidden; border-bottom: 1px solid #d9ac61; }
.hero_background { position: absolute; inset: 0; background-image: linear-gradient(90deg, rgba(255, 250, 240, .99) 0%, rgba(255, 248, 235, .94) 49%, rgba(255, 248, 235, .32) 100%), linear-gradient(180deg, rgba(255, 255, 255, .2) 0%, rgba(255, 242, 218, .62) 100%), url('../images/fine-dining-hero.jpg'); background-repeat: no-repeat; background-position: center, center, 78% 46%; background-size: 100% 100%, 100% 100%, auto 178%; }
.hero_content { position: relative; z-index: 1; padding: 19px 18px 0; }
.account_bar, .balance_top, .balance_stats, .invite_card, .vip_group { display: flex; align-items: center; justify-content: space-between; }
.brand_mark { display: flex; width: 60px; height: 60px; align-items: center; justify-content: center; overflow: hidden; border: 2px solid #c9953e; border-radius: 50%; background: #fffdf7; box-shadow: 0 7px 18px rgba(125, 72, 24, .18), 0 0 0 3px rgba(255, 249, 235, .82); }
.brand_mark img { width: 100%; height: 100%; object-fit: cover; }
.account_identity { min-width: 0; flex: 1; margin-left: 11px; }
.account_name_line { display: flex; min-width: 0; align-items: center; gap: 7px; }
.account_mobile { min-width: 0; overflow: hidden; color: #472217; font-size: 16px; font-weight: 700; line-height: 23px; text-overflow: ellipsis; white-space: nowrap; }
.account_meta { display: flex; align-items: center; gap: 7px; margin-top: 3px; color: #805f4d; font-size: 12px; line-height: 20px; }
.vip_badge { display: inline-flex; max-width: 100px; flex: 0 0 auto; align-items: center; overflow: hidden; padding: 3px 8px; border: 1px solid #b6752e; border-radius: 10px; background: linear-gradient(120deg, #fff6dd, #f2d38e); color: #742118; font-size: 12px; font-weight: 700; line-height: 15px; text-overflow: ellipsis; white-space: nowrap; }
.setting_button, .recharge_button, .copy_button, .logout_button { border: 0; font: inherit; }
.setting_button { display: flex; width: 39px; height: 39px; align-items: center; justify-content: center; border: 1px solid #c7923e; border-radius: 50%; background: rgba(255, 252, 243, .82); box-shadow: 0 5px 12px rgba(125, 72, 24, .16); color: #a66c23; }
.balance_card { margin-top: 22px; padding: 17px 16px 14px; border: 1px solid #d4a24d; border-radius: 17px; background: linear-gradient(135deg, rgba(255, 255, 252, .94), rgba(255, 244, 219, .94)); box-shadow: 0 14px 28px rgba(123, 78, 31, .18), inset 0 1px 0 #fff; backdrop-filter: blur(5px); }
.balance_label, .balance_amount, .stat_item p, .stat_item span { margin: 0; }
.balance_label { color: #87634b; font-size: 12px; }
.balance_amount { margin-top: 4px; color: #8d1f16; font-size: 16px; font-weight: 700; line-height: 26px; letter-spacing: .3px; }
.recharge_button { display: flex; width: 41px; height: 41px; align-items: center; justify-content: center; border: 1px solid #b97926; border-radius: 50%; background: linear-gradient(145deg, #fff4cb, #e5b95f); box-shadow: 0 5px 14px rgba(125, 72, 24, .18); color: #8a2118; font-size: 25px; }
.balance_divider { height: 1px; margin: 13px 0 11px; background: linear-gradient(90deg, transparent, rgba(191, 140, 64, .58), transparent); }
.balance_stats { gap: 12px; }
.stat_item { min-width: 0; flex: 1; }
.stat_item + .stat_item { padding-left: 14px; border-left: 1px solid rgba(191, 140, 64, .34); }
.stat_item p { overflow: hidden; color: #892017; font-size: 16px; font-weight: 700; line-height: 23px; text-overflow: ellipsis; white-space: nowrap; }
.stat_item span { display: block; overflow: hidden; margin-top: 2px; color: #8b6952; font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.user_content { padding: 16px 14px 88px; background: linear-gradient(180deg, #fff9ed, #f8ead4); }
.invite_card { min-height: 60px; padding: 0 14px 0 16px; border: 1px solid #d5a451; border-radius: 14px; background: #fffdf8; box-shadow: 0 9px 18px rgba(130, 77, 28, .12); }
.invite_copy { min-width: 0; }
.invite_copy span, .invite_copy strong { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.invite_copy span { color: #8b6a53; font-size: 12px; }
.invite_copy strong { margin-top: 2px; color: #8d2118; font-size: 16px; font-weight: 700; }
.copy_button { flex: 0 0 auto; margin-left: 15px; padding: 8px 15px; border: 1px solid #b87826; border-radius: 17px; background: linear-gradient(110deg, #fff7e3, #f5d996); color: #7e2017; font-size: 12px; }
.vip_group { position: relative; min-height: 84px; margin-top: 14px; padding: 10px 14px 10px 19px; overflow: hidden; border: 1px solid #c89137; border-radius: 15px; background: linear-gradient(110deg, #fffdf7 0%, #fff5df 56%, #f4d78d 100%); box-shadow: 0 10px 20px rgba(130, 77, 28, .13), inset 0 1px 0 #fff; }
.vip_group::before { position: absolute; top: 13px; bottom: 13px; left: 0; width: 4px; border-radius: 0 4px 4px 0; background: linear-gradient(180deg, #9a251c, #d8a044); content: ''; }
.vip_group_txt { position: relative; z-index: 1; min-width: 0; flex: 1; padding-right: 9px; color: #732219; font-size: 14px; font-weight: 600; line-height: 19px; }
.vip_group_img { position: relative; z-index: 1; width: 86px; max-height: 72px; object-fit: contain; filter: drop-shadow(0 5px 7px rgba(116, 63, 20, .19)); }
.menu_section { margin-top: 16px; }
/deep/ .menu_item.van-cell { display: flex; align-items: center; min-height: 57px; margin-bottom: 11px; padding: 10px 14px; border: 1px solid #dfb566; border-radius: 14px; background: #fffdf8; box-shadow: 0 9px 18px rgba(123, 76, 25, .11), inset 0 1px 0 #fff; color: #492419; }
/deep/ .menu_item.van-cell:active { background: #fff0d0; }
/deep/ .menu_item .van-cell__title { display: flex; min-width: 0; align-items: center; }
/deep/ .menu_item .van-cell__right-icon { margin-left: 10px; color: #af7629; font-size: 17px; }
.menu_icon { display: flex; width: 33px; height: 33px; align-items: center; justify-content: center; margin-right: 12px; border: 1px solid #c78b35; border-radius: 10px; background: linear-gradient(145deg, #fff8e8, #f1d18a); color: #8c2118; }
.custom-title { overflow: hidden; color: #4b291e; font-size: 14px; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.logout_button { display: block; width: 100%; min-height: 50px; margin-top: 38px; border: 1px solid #bd7e2c; border-radius: 14px; background: #fffdf8; color: #8b2118; font-size: 14px; font-weight: 600; letter-spacing: .4px; box-shadow: 0 8px 16px rgba(123, 76, 25, .1); }
.logout_button:active, .copy_button:active, .setting_button:active, .recharge_button:active { opacity: .78; }
.notice_popup { width: 70%; padding: 15px; border: 1px solid rgba(230, 182, 105, .55); background: #21110c; color: #fff0d4; font-weight: 600; line-height: 30px; }
@media (max-width: 340px) { .hero_content { padding-right: 12px; padding-left: 12px; } .balance_card { padding-right: 13px; padding-left: 13px; } .account_meta { gap: 4px; } .user_content { padding-right: 10px; padding-left: 10px; } .vip_group { padding-right: 13px; padding-left: 13px; } }
</style>
